import { render, staticRenderFns } from "./VUserRound.vue?vue&type=template&id=1512e703&"
import script from "./VUserRound.vue?vue&type=script&lang=ts&"
export * from "./VUserRound.vue?vue&type=script&lang=ts&"
import style0 from "./VUserRound.vue?vue&type=style&index=0&id=1512e703&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports